import { render, staticRenderFns } from "./LevellingFrameworkPage.vue?vue&type=template&id=729c46e9&scoped=true"
import script from "./LevellingFrameworkPage.vue?vue&type=script&lang=js"
export * from "./LevellingFrameworkPage.vue?vue&type=script&lang=js"
import style0 from "./LevellingFrameworkPage.vue?vue&type=style&index=0&id=729c46e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c46e9",
  null
  
)

export default component.exports